module.exports = "/images/icon_bookings.png?65855b9d6af4e13aa2fcdc046d6fbbf7";